<template>
  <div class="center_box">
    <Header style="margin-top:30px;"></Header>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>
        <router-link to="/">{{$t('message.homepage')}}</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>{{$t('message.product')}}</el-breadcrumb-item>
      <el-breadcrumb-item>{{$t('message.ApplicationSelection')}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div><h1 style="font-size:34px;padding-top:20px;padding-bottom:20px;">{{$t('message.ApplicationSelection')}}</h1></div>
    <SelectedApp v-on:listenPageChange="listenPageChange" v-show="AppPage"></SelectedApp>
    <SelectedReducerLoad ref="SelectedReducerLoad" :paramLoad="paramLoad" v-on:listenParam_2="listenParam_2" v-on:listenParam_3="listenParam_3" v-on:listenPageChange="listenPageChange" v-show="ReducerLoadPage"></SelectedReducerLoad>
    <SelectedReducerSize ref="SelectedReducerSize" :param_2="param_2" v-on:listenParam_4="listenParam_4" v-on:listenPageChange="listenPageChange" v-show="ReducerSizePage"></SelectedReducerSize>
    <SelectedMotor ref="SelectedMotor" :param_4="param_4" v-on:listenParam_5="listenParam_5" v-on:listenPageChange="listenPageChange" v-show="MotorPage"></SelectedMotor>
    <SelectedCompleted ref="SelectedCompleted" v-on:listenPageChange="listenPageChange" :param_5="param_5" v-show="CompletedPage"></SelectedCompleted>
    <!-- 子组件 -->
    <SelectedAGV v-on:listenParam="listenParam" v-on:listenPageChange="listenPageChange" v-show="AGVPage"></SelectedAGV>
    <SelectedConveyorBelt v-on:listenParam="listenParam" v-on:listenPageChange="listenPageChange" v-show="ConveyorBeltPage"></SelectedConveyorBelt>
    <SelectedGearRotation v-on:listenParam="listenParam" v-on:listenPageChange="listenPageChange" v-show="GearRotationPage"></SelectedGearRotation>
    <SelectedLifter v-on:listenParam="listenParam" v-on:listenPageChange="listenPageChange" v-show="LifterPage"></SelectedLifter>
    <SelectedRack v-on:listenParam="listenParam" v-on:listenPageChange="listenPageChange" v-show="RackPage"></SelectedRack>
    <SelectedScrew v-on:listenParam="listenParam" v-on:listenPageChange="listenPageChange" v-show="ScrewPage"></SelectedScrew>
    <SelectedTimingBelt v-on:listenParam="listenParam" v-on:listenPageChange="listenPageChange" v-show="TimingBeltPage"></SelectedTimingBelt>
    <SelectedTurnTable v-on:listenParam="listenParam" v-on:listenPageChange="listenPageChange" v-show="TurnTablePage"></SelectedTurnTable>
    <BackTop></BackTop>
  </div>
</template>
<script>
import Header from '../Header'
import BackTop from '../BackTop'
import SelectedApp from './SelectedApp'
import SelectedReducerLoad from './SelectedReducerLoad'
import SelectedReducerSize from './SelectedReducerSize'
import SelectedMotor from './SelectedMotor'
import SelectedCompleted from './SelectedCompleted'
/* 应用负载条件子页面 */
import SelectedAGV from './SelectedAppLoad/SelectedAGV'
import SelectedConveyorBelt from './SelectedAppLoad/SelectedConveyorBelt'
import SelectedGearRotation from './SelectedAppLoad/SelectedGearRotation'
import SelectedLifter from './SelectedAppLoad/SelectedLifter'
import SelectedRack from './SelectedAppLoad/SelectedRack'
import SelectedScrew from './SelectedAppLoad/SelectedScrew'
import SelectedTimingBelt from './SelectedAppLoad/SelectedTimingBelt'
import SelectedTurnTable from './SelectedAppLoad/SelectedTurnTable'
export default {
  name: 'ApplicationSelection',
  components: {
    SelectedApp,
    SelectedReducerLoad,
    SelectedReducerSize,
    SelectedMotor,
    SelectedCompleted,
    SelectedTurnTable,
    SelectedAGV,
    SelectedConveyorBelt,
    SelectedGearRotation,
    SelectedLifter,
    SelectedRack,
    SelectedScrew,
    SelectedTimingBelt,
    BackTop,
    Header
  },
  data () {
    return {
      AppPage : true,
      ReducerLoadPage : false,
      ReducerSizePage : false,
      MotorPage : false,
      CompletedPage : false,
      // app下子组件
      TurnTablePage : false,
      AGVPage : false,
      ConveyorBeltPage : false,
      GearRotationPage : false,
      LifterPage : false,
      RackPage : false,
      ScrewPage : false,
      TimingBeltPage : false,
      // 给减速机负载页面的参数
      paramLoad: {},
      param_2:{},
      param_3:{},
      param_4:{},
      param_5:{}
    }
  },
  methods:{
    listenPageChange:function(data) {
      if(data === 'to_AppPage'){
        this.AppPage = true
        this.ReducerLoadPage = false
        this.ReducerSizePage = false
        this.MotorPage = false
        this.CompletedPage = false
        //App下子组件
        this.TurnTablePage = false
        this.AGVPage = false
        this.ConveyorBeltPage = false
        this.GearRotationPage = false
        this.LifterPage = false
        this.RackPage = false
        this.ScrewPage = false
        this.TimingBeltPage = false
      }else if(data === 'to_TurnTablePage') {
        this.AppPage = false
        this.ReducerLoadPage = false
        this.ReducerSizePage = false
        this.MotorPage = false
        this.CompletedPage = false
        //App下子组件
        this.TurnTablePage = true
        this.AGVPage = false
        this.ConveyorBeltPage = false
        this.GearRotationPage = false
        this.LifterPage = false
        this.RackPage = false
        this.ScrewPage = false
        this.TimingBeltPage = false
      }else if(data === 'to_AGVPage') {
        this.AppPage = false
        this.ReducerLoadPage = false
        this.ReducerSizePage = false
        this.MotorPage = false
        this.CompletedPage = false
        //App下子组件
        this.TurnTablePage = false
        this.AGVPage = true
        this.ConveyorBeltPage = false
        this.GearRotationPage = false
        this.LifterPage = false
        this.RackPage = false
        this.ScrewPage = false
        this.TimingBeltPage = false
      }else if(data === 'to_ConveyorBeltPage') {
        this.AppPage = false
        this.ReducerLoadPage = false
        this.ReducerSizePage = false
        this.MotorPage = false
        this.CompletedPage = false
        //App下子组件
        this.TurnTablePage = false
        this.AGVPage = false
        this.ConveyorBeltPage = true
        this.GearRotationPage = false
        this.LifterPage = false
        this.RackPage = false
        this.ScrewPage = false
        this.TimingBeltPage = false
      }else if(data === 'to_GearRotationPage') {
        this.AppPage = false
        this.ReducerLoadPage = false
        this.ReducerSizePage = false
        this.MotorPage = false
        this.CompletedPage = false
        //App下子组件
        this.TurnTablePage = false
        this.AGVPage = false
        this.ConveyorBeltPage = false
        this.GearRotationPage = true
        this.LifterPage = false
        this.RackPage = false
        this.ScrewPage = false
        this.TimingBeltPage = false
      }else if(data === 'to_LifterPage') {
        this.AppPage = false
        this.ReducerLoadPage = false
        this.ReducerSizePage = false
        this.MotorPage = false
        this.CompletedPage = false
        //App下子组件
        this.TurnTablePage = false
        this.AGVPage = false
        this.ConveyorBeltPage = false
        this.GearRotationPage = false
        this.LifterPage = true
        this.RackPage = false
        this.ScrewPage = false
        this.TimingBeltPage = false
      }else if(data === 'to_RackPage') {
        this.AppPage = false
        this.ReducerLoadPage = false
        this.ReducerSizePage = false
        this.MotorPage = false
        this.CompletedPage = false
        //App下子组件
        this.TurnTablePage = false
        this.AGVPage = false
        this.ConveyorBeltPage = false
        this.GearRotationPage = false
        this.LifterPage = false
        this.RackPage = true
        this.ScrewPage = false
        this.TimingBeltPage = false
      }else if(data === 'to_ScrewPage') {
        this.AppPage = false
        this.ReducerLoadPage = false
        this.ReducerSizePage = false
        this.MotorPage = false
        this.CompletedPage = false
        //App下子组件
        this.TurnTablePage = false
        this.AGVPage = false
        this.ConveyorBeltPage = false
        this.GearRotationPage = false
        this.LifterPage = false
        this.RackPage = false
        this.ScrewPage = true
        this.TimingBeltPage = false
      }else if(data === 'to_TimingBeltPage') {
        this.AppPage = false
        this.ReducerLoadPage = false
        this.ReducerSizePage = false
        this.MotorPage = false
        this.CompletedPage = false
        //App下子组件
        this.TurnTablePage = false
        this.AGVPage = false
        this.ConveyorBeltPage = false
        this.GearRotationPage = false
        this.LifterPage = false
        this.RackPage = false
        this.ScrewPage = false
        this.TimingBeltPage = true
      }else if(data === 'to_ReducerLoadPage') {
        // 执行该子组件方法
        this.$refs.SelectedReducerLoad.loadConditionalAssignment(this.paramLoad);

        this.AppPage = false
        this.ReducerLoadPage = true
        this.ReducerSizePage = false
        this.MotorPage = false
        this.CompletedPage = false
        //App下子组件
        this.TurnTablePage = false
        this.AGVPage = false
        this.ConveyorBeltPage = false
        this.GearRotationPage = false
        this.LifterPage = false
        this.RackPage = false
        this.ScrewPage = false
        this.TimingBeltPage = false
      }else if(data === 'to_ReducerSizePage') {
        // 执行该子组件方法
        this.$refs.SelectedReducerSize._getListReducerisAble(this.param_2,this.param_3);

        this.AppPage = false
        this.ReducerLoadPage = false
        this.ReducerSizePage = true
        this.MotorPage = false
        this.CompletedPage = false
        //App下子组件
        this.TurnTablePage = false
        this.AGVPage = false
        this.ConveyorBeltPage = false
        this.GearRotationPage = false
        this.LifterPage = false
        this.RackPage = false
        this.ScrewPage = false
        this.TimingBeltPage = false
      }else if(data === 'to_MotorPage') {
        // 执行该子组件方法
        this.$refs.SelectedMotor._getavailablemotorfactory(this.param_4);

        this.AppPage = false
        this.ReducerLoadPage = false
        this.ReducerSizePage = false
        this.MotorPage = true
        this.CompletedPage = false
        //App下子组件
        this.TurnTablePage = false
        this.AGVPage = false
        this.ConveyorBeltPage = false
        this.GearRotationPage = false
        this.LifterPage = false
        this.RackPage = false
        this.ScrewPage = false
        this.TimingBeltPage = false
      }else if(data === 'to_CompletedPage') {
        // 执行该子组件方法
        this.$refs.SelectedCompleted._getinfobyreducersize(this.param_5);
        this.$refs.SelectedCompleted._getinfobyfactoryandsize(this.param_5);
        this.AppPage = false
        this.ReducerLoadPage = false
        this.ReducerSizePage = false
        this.MotorPage = false
        this.CompletedPage = true
        //App下子组件
        this.TurnTablePage = false
        this.AGVPage = false
        this.ConveyorBeltPage = false
        this.GearRotationPage = false
        this.LifterPage = false
        this.RackPage = false
        this.ScrewPage = false
        this.TimingBeltPage = false
      }
    },
    listenParam:function(data){
      this.paramLoad = data;
    },
    listenParam_2:function(data){
      this.param_2 = data;
    },
    listenParam_3:function(data){
      this.param_3.reducer_series_name = data;
    },
    listenParam_4:function(data){
      this.param_4.reducer_size = data;
    },
    listenParam_5:function(data){
      this.param_5.reducer_size = this.param_4.reducer_size
      this.param_5.motor_factory = data.motor_factory;
      this.param_5.motor_type = data.motor_type;
    }
  }
}
</script>
<style scoped>
  .center_box {
    width:75%;
    margin:0 auto;
    height:100%;
  }
  .el-breadcrumb {
    font-size: 18px;
    padding-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/view/ApplicationSelection/ApplicationSelection.vue